(function () {
  var sections = document.querySelectorAll('.oddit-section-main-product');
  if (!sections.length) return;

  sections.forEach(function (section) {
    initThumbnails(section);
    initQuantityOptions(section);
    initSubscriptionOptions(section);
    initSellingPlanSelect(section);
    initAddToCart(section);
    // Apply the active tier's state to local DOM immediately.
    applyPackState(section, readPackState(section));
    // Defer the cross-section broadcast so listeners (e.g. sticky ATC) have a
    // chance to register — both scripts are deferred and run in document order.
    setTimeout(function () {
      dispatchQuantityChange(section, readPackState(section));
    }, 0);
  });

  /* ----------------------------------------------------------------------
     Money formatting — matches Liquid's `money_without_trailing_zeros`
     ---------------------------------------------------------------------- */
  function formatMoneyNoZeros(cents) {
    var amount = (Number(cents) || 0) / 100;
    var isWhole = cents % 100 === 0;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: isWhole ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return (isWhole ? amount.toFixed(0) : amount.toFixed(2)) + ' ' + currency;
    }
  }

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  /* ----------------------------------------------------------------------
     Quantity tier state
     ---------------------------------------------------------------------- */
  function readPackState(section) {
    var picker = section.querySelector('[data-quantity-picker]');
    var active = picker
      ? picker.querySelector('.oddit-section-main-product__quantity-option--active')
        || picker.querySelector('[data-pack-select]')
      : null;

    if (active) {
      return {
        count: Number(active.getAttribute('data-pack-count')) || 1,
        discountPct: Number(active.getAttribute('data-pack-discount')) || 0,
        totalCents: Number(active.getAttribute('data-pack-total-cents')) || 0,
        subtotalCents: Number(active.getAttribute('data-pack-subtotal-cents')) || 0,
        label: active.getAttribute('data-pack-label') || ''
      };
    }

    // No picker (e.g. product tagged with the exclude tag) — qty defaults to 1.
    var unitCents = Number(section.getAttribute('data-unit-price')) || 0;
    return {
      count: 1,
      discountPct: 0,
      totalCents: unitCents,
      subtotalCents: unitCents,
      label: ''
    };
  }

  /* ----------------------------------------------------------------------
     Selling plan / subscription state
     ---------------------------------------------------------------------- */
  function getActiveSubscriptionMode(section) {
    var block = section.querySelector('[data-subscription-block]');
    if (!block) return 'onetime';
    var subscribeActive = block.querySelector(
      '[data-subscription-option="subscribe"].oddit-section-main-product__subscription--active'
    );
    return subscribeActive ? 'subscribe' : 'onetime';
  }

  function getActiveSellingPlanAdjustment(section) {
    var subscribeOption = section.querySelector('[data-subscription-option="subscribe"]');
    if (!subscribeOption) return null;

    var select = subscribeOption.querySelector('[data-selling-plan-select]');
    if (select && select.selectedOptions && select.selectedOptions[0]) {
      var opt = select.selectedOptions[0];
      return {
        type: opt.getAttribute('data-discount-type') || '',
        value: Number(opt.getAttribute('data-discount-value')) || 0,
        planId: select.value || null
      };
    }
    return {
      type: subscribeOption.getAttribute('data-discount-type') || '',
      value: Number(subscribeOption.getAttribute('data-discount-value')) || 0,
      planId: subscribeOption.getAttribute('data-active-plan-id') || null
    };
  }

  function applyAdjustment(totalCents, packCount, adj) {
    if (!adj || !adj.type) return totalCents;
    if (adj.type === 'percentage') {
      return Math.round(totalCents - (totalCents * adj.value / 100));
    }
    if (adj.type === 'fixed_amount') {
      // adj.value is a per-unit discount amount.
      return Math.max(0, totalCents - (adj.value * packCount));
    }
    if (adj.type === 'price') {
      // adj.value is the fixed unit price the customer pays.
      return adj.value * packCount;
    }
    return totalCents;
  }

  /* ----------------------------------------------------------------------
     DOM updates + event dispatch
     ---------------------------------------------------------------------- */
  function applyPackState(section, state) {
    var labelValue = section.querySelector('[data-quantity-label-value]');
    if (labelValue && state.label) labelValue.textContent = state.label;

    var adj = getActiveSellingPlanAdjustment(section);
    var subscribeTotal = applyAdjustment(state.totalCents, state.count, adj);

    var subPrice = section.querySelector('[data-subscribe-price]');
    var subStrike = section.querySelector('[data-subscribe-strike]');
    if (subPrice) subPrice.textContent = formatMoneyNoZeros(subscribeTotal);
    if (subStrike) {
      if (adj && adj.type && subscribeTotal !== state.totalCents) {
        subStrike.textContent = formatMoneyNoZeros(state.totalCents);
        subStrike.removeAttribute('hidden');
      } else {
        subStrike.setAttribute('hidden', '');
      }
    }

    var subBadge = section.querySelector('[data-subscribe-badge][data-subscribe-badge-auto="amount"]');
    if (subBadge) {
      var savingsCents = state.totalCents - subscribeTotal;
      // Format: "£X.XX SAVED" (amount first, two decimals) to match the server render.
      subBadge.textContent = savingsCents > 0 ? formatMoney(savingsCents) + ' SAVED' : '';
    }

    var oneTime = section.querySelector('[data-onetime-price]');
    if (oneTime) oneTime.textContent = formatMoneyNoZeros(state.totalCents);

    var atc = section.querySelector('[data-add-to-cart][data-variant-id]');
    if (atc) atc.setAttribute('data-quantity', String(state.count));
  }

  function dispatchQuantityChange(section, state) {
    var adj = getActiveSellingPlanAdjustment(section);
    var subscribeTotal = applyAdjustment(state.totalCents, state.count, adj);
    var mode = getActiveSubscriptionMode(section);
    var planId = (mode === 'subscribe' && adj && adj.planId) ? adj.planId : null;

    updateDynamicCheckout(section, state, mode, planId);

    document.dispatchEvent(new CustomEvent('oddit:quantity-change', {
      detail: {
        sectionId: section.id,
        productId: section.getAttribute('data-product-id'),
        variantId: section.getAttribute('data-variant-id'),
        count: state.count,
        discountPct: state.discountPct,
        totalCents: state.totalCents,
        subtotalCents: state.subtotalCents,
        subscribeTotalCents: subscribeTotal,
        sellingPlanId: planId,
        subscriptionMode: mode,
        label: state.label,
        formattedTotal: formatMoneyNoZeros(state.totalCents),
        formattedSubtotal: formatMoneyNoZeros(state.subtotalCents),
        formattedSubscribeTotal: formatMoneyNoZeros(subscribeTotal)
      }
    }));
  }

  function syncFromActiveTier(section) {
    var state = readPackState(section);
    applyPackState(section, state);
    dispatchQuantityChange(section, state);
  }

  /* ----------------------------------------------------------------------
     MBG-116: dynamic checkout (Apple Pay / Shop Pay) form sync
     ---------------------------------------------------------------------- */
  function updateDynamicCheckout(section, state, mode, planId) {
    var form = section.querySelector('[data-dynamic-checkout-form]');
    if (!form) return;

    var variantInput = form.querySelector('[data-dynamic-variant-id]');
    if (variantInput) variantInput.value = section.getAttribute('data-variant-id') || variantInput.value;

    var qtyInput = form.querySelector('[data-dynamic-quantity]');
    if (qtyInput) qtyInput.value = String(state.count || 1);

    var planInput = form.querySelector('[data-dynamic-selling-plan]');
    if (planInput) {
      if (mode === 'subscribe' && planId) {
        planInput.value = String(planId);
        planInput.disabled = false;
      } else {
        // Disabled inputs are omitted from the form submission — keeps one-time
        // purchases free of a selling_plan.
        planInput.value = '';
        planInput.disabled = true;
      }
    }
  }

  /* ----------------------------------------------------------------------
     Thumbnail switching
     ---------------------------------------------------------------------- */
  function initThumbnails(section) {
    var thumbs = section.querySelectorAll('.oddit-section-main-product__thumbnail');
    if (!thumbs.length) return;

    var slides = section.querySelectorAll('.oddit-section-main-product__main-image');
    var carousel = section.querySelector('.oddit-section-main-product__main-images');

    function syncSlideVideos(activeIndex) {
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (i === activeIndex) {
          video.muted = true;
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          video.pause();
        }
      });
    }

    function setActiveThumb(index) {
      thumbs.forEach(function (t) {
        t.classList.remove('oddit-section-main-product__thumbnail--active');
      });
      if (thumbs[index]) {
        thumbs[index].classList.add('oddit-section-main-product__thumbnail--active');
      }
      slides.forEach(function (slide, i) {
        slide.classList.toggle('oddit-section-main-product__main-image--active', i === index);
      });
      syncSlideVideos(index);
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        setActiveThumb(index);

        var targetSlide = slides[index];
        if (targetSlide && typeof targetSlide.scrollIntoView === 'function') {
          targetSlide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      });

      // MBG-97: stop-motion thumbnail videos autoplay on load (muted, looping) —
      // no hover/click needed. The `autoplay` attribute is the primary trigger;
      // this play() call is a fallback for browsers that don't honour it.
      var thumbVideo = thumb.querySelector('video');
      if (thumbVideo) {
        thumbVideo.muted = true;
        var tp = thumbVideo.play();
        if (tp && typeof tp.catch === 'function') tp.catch(function () {});
      }
    });

    /* Autoplay the active slide's video once it scrolls into view (muted, lazy) */
    if ('IntersectionObserver' in window) {
      var galleryObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target.querySelector('video');
            if (!video) return;
            if (entry.isIntersecting) {
              video.muted = true;
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.4 }
      );
      slides.forEach(function (slide) {
        if (slide.querySelector('video')) galleryObserver.observe(slide);
      });
    } else {
      syncSlideVideos(0);
    }

    if (carousel && slides.length) {
      var scrollTimer;
      carousel.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var carouselRect = carousel.getBoundingClientRect();
          var paddingLeft = parseFloat(getComputedStyle(carousel).paddingLeft) || 0;
          var bestIndex = 0;
          var bestDistance = Infinity;
          slides.forEach(function (slide, i) {
            var slideRect = slide.getBoundingClientRect();
            var distance = Math.abs(slideRect.left - carouselRect.left - paddingLeft);
            if (distance < bestDistance) {
              bestDistance = distance;
              bestIndex = i;
            }
          });
          setActiveThumb(bestIndex);
        }, 80);
      }, { passive: true });
    }
  }

  /* ----------------------------------------------------------------------
     Quantity tier selection (1 / 2 / 3 Pack)
     ---------------------------------------------------------------------- */
  function initQuantityOptions(section) {
    var picker = section.querySelector('[data-quantity-picker]');
    if (!picker) return;

    var options = picker.querySelectorAll('[data-pack-select]');
    if (!options.length) return;

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        options.forEach(function (o) {
          o.classList.remove('oddit-section-main-product__quantity-option--active');
        });
        option.classList.add('oddit-section-main-product__quantity-option--active');
        syncFromActiveTier(section);
      });
    });
  }

  /* ----------------------------------------------------------------------
     Subscription option (Subscribe & Save / One-time) selection
     ---------------------------------------------------------------------- */
  function initSubscriptionOptions(section) {
    var subs = section.querySelectorAll('.oddit-section-main-product__subscription');
    if (!subs.length) return;

    subs.forEach(function (sub) {
      sub.addEventListener('click', function (e) {
        // Clicks within the delivery row (dropdown / native select) shouldn't toggle modes.
        if (e.target.closest('.oddit-section-main-product__delivery')) return;

        subs.forEach(function (s) {
          s.classList.remove('oddit-section-main-product__subscription--active');
        });
        sub.classList.add('oddit-section-main-product__subscription--active');

        var labelValue = section.querySelector('.oddit-section-main-product__frequency-label-value');
        var freqLabel = sub.getAttribute('data-frequency-label');
        if (labelValue && freqLabel) {
          labelValue.textContent = freqLabel;
        }

        // Rebroadcast so ATC payload + sticky ATC reflect the active mode.
        syncFromActiveTier(section);
      });
    });
  }

  /* ----------------------------------------------------------------------
     Selling plan dropdown (visible only when product has >1 selling plan)
     ---------------------------------------------------------------------- */
  function initSellingPlanSelect(section) {
    var select = section.querySelector('[data-selling-plan-select]');
    if (!select) return;

    select.addEventListener('change', function () {
      // Switching plans implies the customer wants subscribe mode.
      var subscribeOption = section.querySelector('[data-subscription-option="subscribe"]');
      if (subscribeOption && !subscribeOption.classList.contains('oddit-section-main-product__subscription--active')) {
        var subs = section.querySelectorAll('.oddit-section-main-product__subscription');
        subs.forEach(function (s) {
          s.classList.remove('oddit-section-main-product__subscription--active');
        });
        subscribeOption.classList.add('oddit-section-main-product__subscription--active');

        var labelValue = section.querySelector('.oddit-section-main-product__frequency-label-value');
        var freqLabel = subscribeOption.getAttribute('data-frequency-label');
        if (labelValue && freqLabel) {
          labelValue.textContent = freqLabel;
        }
      }
      syncFromActiveTier(section);
    });
  }

  /* ----------------------------------------------------------------------
     Add to cart — posts {id, quantity, selling_plan?} via OdditCartDrawer if
     available, otherwise falls back to a direct /cart/add.js request.
     ---------------------------------------------------------------------- */
  function initAddToCart(section) {
    var atc = section.querySelector('[data-add-to-cart][data-variant-id]');
    if (!atc) return;

    atc.addEventListener('click', function (e) {
      e.preventDefault();
      if (atc.disabled) return;

      var variantId = atc.getAttribute('data-variant-id');
      if (!variantId) return;
      var quantity = Number(atc.getAttribute('data-quantity')) || 1;

      var mode = getActiveSubscriptionMode(section);
      var sellingPlanId = null;
      if (mode === 'subscribe') {
        var adj = getActiveSellingPlanAdjustment(section);
        if (adj && adj.planId) sellingPlanId = adj.planId;
      }

      atc.disabled = true;
      atc.classList.add('is-loading');

      var addPromise;
      if (window.OdditCartDrawer && typeof window.OdditCartDrawer.addToCart === 'function') {
        addPromise = window.OdditCartDrawer.addToCart(Number(variantId), quantity, null, sellingPlanId).then(function () {
          if (typeof window.OdditCartDrawer.open === 'function') window.OdditCartDrawer.open();
        });
      } else {
        var body = { id: Number(variantId), quantity: quantity };
        if (sellingPlanId) body.selling_plan = Number(sellingPlanId);
        addPromise = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(body)
        }).then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          window.location.href = '/cart';
        });
      }

      addPromise
        .catch(function (err) {
          console.error('Add to cart failed:', err);
        })
        .then(function () {
          atc.disabled = false;
          atc.classList.remove('is-loading');
        });
    });
  }
})();
